import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const notificationStyles: any = makeStyles()((_theme: Theme) => {
  return {
    menuRoot: {
      width: '30vw',
      overflow: 'hidden',
      [_theme.breakpoints.between('sm', 'xs')]: {
        width: '80vw',
      },
      [_theme.breakpoints.down('md')]: {
        width: '50vw',
      },
      [_theme.breakpoints.up('lg')]: {
        width: '30vw',
      },
    },
    topScrollPaper: {
      alignItems: 'flex-start',
      justifyContent: 'end',
      marginRight: '20px',
      [_theme.breakpoints.down('xs')]: {
        marginRight: '3%',
      },
    },
    topPaperScrollBody: {
      verticalAlign: 'top',
    },
    cardNotification: {
      borderBottomRightRadius: '14px',
      borderBottomLeftRadius: '14px',
    },
    paperDialog: {
      margin: '80px 0 0 !important',
      position: 'absolute',
      overflowY: 'initial',
      borderBottomRightRadius: '14px',
      borderBottomLeftRadius: '14px',
      boxShadow:
        '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
      '&::after': {
        content: `''`,
        position: 'absolute',
        width: 0,
        height: 0,
        right: '2px',
        top: '-25px',
        border: '15px solid',
        borderColor: 'transparent transparent white transparent',
        zIndex: 2,
      },
      [_theme.breakpoints.down('xs')]: {
        '@supports (-webkit-touch-callout: none)': {
          margin: '70px 50px 0 !important',
          '&::after': {
            right: '7px',
          },
        },
        '@supports not (-webkit-touch-callout: none)': {
          margin: '70px 0 0 !important',
          '&::after': {
            right: '7px',
          },
        },
      },
    },
    cardContent: {
      padding: 0,
      maxHeight: '45vh',
      minHeight: '15vh',
      overflowY: 'auto',
    },
    closeButton: {
      position: 'absolute',
      width: '25px',
      height: '25px',
      left: '-10px',
      top: '-7px',
      backgroundColor: _theme.palette.primary.main,
      zIndex: 2,
      borderRadius: '50%',
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#FFF',
      cursor: 'pointer',
    },
    nameNotification: {
      fontFamily: 'Gotham Rounded Bold',
      margin: 0,
    },
    descriptionText: {
      margin: 0,
    },
    alertIcon: {
      fill: _theme.palette.secondary.main,
      position: 'absolute',
      left: '1vh',
      zIndex: 1,
    },
    checkIcon: {
      fill: '#E9E9E9',
      position: 'absolute',
      left: '1vh',
      zIndex: 1,
    },
  };
});
